import type { User } from "@/types/user";

const PROVIDER_LABELS: Record<string, string> = {
	google: "Google",
	github: "GitHub",
	azure: "Microsoft",
	microsoft: "Microsoft",
	email: "Email",
};

export function getDisplayName(user: User | null | undefined): string {
	if (!user) return "";
	return user.full_name?.trim() || (user.email?.split("@")[0] ?? "");
}

export function getInitials(user: User | null | undefined): string {
	const source = getDisplayName(user);
	if (!source) return "?";
	const parts = source.split(/[\s._-]+/).filter(Boolean);
	return parts
		.slice(0, 2)
		.map((p) => p[0])
		.join("")
		.toUpperCase();
}

/** Human label for the user's global role (user type). */
export function getRoleLabel(user: User | null | undefined): string | null {
	const raw = user?.global_role?.name ?? user?.role;
	if (!raw) return null;
	return raw
		.split(/[\s._-]+/)
		.filter(Boolean)
		.map((w) => w[0].toUpperCase() + w.slice(1).toLowerCase())
		.join(" ");
}

export function getRoleKey(user: User | null | undefined): string | null {
	return user?.global_role?.key ?? user?.role ?? null;
}

/** Identity provider the session was established with, null for password logins. */
export function getSsoProvider(user: User | null | undefined): string | null {
	const provider = user?.auth_provider;
	if (!provider || provider === "email") return null;
	return provider;
}

export function getProviderLabel(provider: string): string {
	return (
		PROVIDER_LABELS[provider] ??
		provider[0].toUpperCase() + provider.slice(1)
	);
}
